import { render, staticRenderFns } from "./MyCSSStyle.vue?vue&type=template&id=2dca2ee1&scoped=true&"
import script from "./MyCSSStyle.vue?vue&type=script&lang=js&"
export * from "./MyCSSStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dca2ee1",
  null
  
)

export default component.exports